module.exports = __webpack_public_path__ + "img/Asian_Quinoa.aa9923a7.jpg";